import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { reveniIntegrationQuery } from "modules/settings/lib/reveni/reveniIntegrationQuery"
import {
  DataResponse,
  ReveniIntegrationResponseDataSchema,
  UpsertReveniIntegrationSchema,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ReveniIntegrationResponseDataSchema>>

export function useUpsertReveniIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof UpsertReveniIntegrationSchema>) => {
      const response = await axios.post<Response>(`/integrations/reveni/configuration`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: reveniIntegrationQuery().queryKey })
    },
  })
}
